export const REGEX_PHONE_NUMBER = /^0?(2|[35789])[0-9]{8}$|^02[48][0-9]{8}$/;
export const REGEX_ONLY_NUMBER = /^\d+$/;
export const REGEX_EMAIL = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const STORAGE_TOKEN = "storage_auth_token";
export const STORAGE_USER_INFO = "storage_user_info";
export const PAGE_SIZE = 10;
export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT = "HH:mm";
export const DATE_TIME_FORMAT = `HH:mm DD/MM/YYYY`;

export const WORKING_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  ACTIVE_LABEL: "Làm việc",
  INACTIVE_LABEL: "Nghỉ việc",
};

export const STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  ACTIVE_LABEL: "Hoạt động",
  INACTIVE_LABEL: "Tạm khóa",
  DANG_SU_DUNG: "Đang sử dụng",
  KHONG_SU_DUNG: "Không sử dụng",
  DA_XAC_NHAN: "Đã xác nhận",
  CHUA_XAC_NHAN: "Chưa xác nhận",
};

export const STATUS_KEY = {
  ACTIVE: "ACTIVE",
  LOCKED: "LOCKED",
  ACTIVE_LABEL: "Hoạt động",
  LOCKED_LABEL: "Đã khóa",
};

export const DEFAULT_PAGINATION = {
  page: 1,
  limit: PAGE_SIZE,
  search: "",
};
